'use client';

import { Chip } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';

export interface FilterOption {
  label: string;
  value: string;
}

interface SliderFilterProps {
  filters: FilterOption[];
  activeFilter: string;
  onFilterChange: (filterValue: string) => void;
  isBackgroundBlack?: boolean;
  className?: string;
}

export default function SliderFilters({
  filters,
  activeFilter,
  onFilterChange,
  isBackgroundBlack,
  className,
}: SliderFilterProps) {
  return (
    <div
      className={clsx(
        'flex overflow-x-auto scroll-smooth px-4 pb-4 no-scrollbar sm:px-6 md:px-8 md:pb-6 lg:px-16 xl:px-22.5',
        className
      )}
    >
      {filters.map((filter) => (
        <Chip
          key={filter.value}
          selected={activeFilter === filter.value}
          variant={isBackgroundBlack ? 'secondary' : 'primary'}
          className={clsx(
            'mr-2 whitespace-nowrap',
            activeFilter === filter.value && 'pointer-events-none'
          )}
          color = {isBackgroundBlack ? "white" : undefined}
          selectedColor={isBackgroundBlack ? "black" : undefined}
          selectedTextColor={isBackgroundBlack ? "white" : undefined}
          onClick={() => onFilterChange(filter.value)}
        >
          {filter.label}
        </Chip>
      ))}
    </div>
  );
}
